// extracted by mini-css-extract-plugin
module.exports = {"main":"PageBody_main__oGv2Z","noMargin":"PageBody_noMargin__1ZX0l","dashboard":"PageBody_dashboard__pCKim","not-found-page":"not-found-page"};